<template>
    <div class="fintscore-report">
        <!-- <div class="under-development rounded">
            <h3 class="text-white">WORK IN PROGRESS</h3>
        </div> -->
        <b-card no-body>
            <b-card-header class="py-2 px-3 d-flex align-items-center justify-content-between">
                <h4 class="mb-0">Prescreening Analysis Report</h4>
                <!-- <el-button type="text" 
                    @click="generateFintscoreHandler" 
                    :loading="is_loading_refresh" 
                    v-if="current_commitment && !current_customer.cjp_id"
                    v-b-tooltip.hover="'Generate Prescreening Analysis Report'"
                >
                    <b-icon icon="file-earmark-bar-graph-fill"></b-icon>
                </el-button> -->
            </b-card-header>
            <div class="px-3 py-2">
                <b-row class="align-items-center">
                    <b-col cols="12" class="d-flex justify-content-center py-2">
                        <div v-loading="is_loading_refresh">
                            <div class="d-flex justify-content-between mb-2">
                                <small v-if="current_commitment">Updated {{ current_commitment.credit_report_response_datetime | dateFormatString }}</small>
                                <el-button class="float-right py-0" type="text" @click="$refs.drawer_fintscore_history.openDrawer()">
                                    <small>Report History </small>
                                    <b-icon icon="chevron-right"></b-icon>
                                </el-button>
                            </div>
                                <b-button-group class="border w-100">
                                    <!-- <b-button class="border-left"
                                        v-if="!(_gHlp.checkAccess(['cr_hide_fintscore__report']))"
                                        :disabled="!current_commitment || current_commitment.credit_report_fintscore_unsigned_url === ''"
                                        @click="$refs.preview_modal.preview(current_commitment.credit_report_fintscore_unsigned_url)"
                                    >
                                        <b-icon icon="cloud-download" variant="primary"></b-icon>
                                        <h5 class="text-primary mb-0 mt-2">Prescreening Analysis Report</h5>
                                    </b-button> -->
                                    <!-- <b-button class="border-right"
                                        :disabled="!current_commitment || current_commitment.credit_report_pdf_unsigned_url === ''"
                                        @click="$refs.preview_modal.preview(current_commitment.credit_report_pdf_unsigned_url)"
                                    >
                                        <b-icon icon="cloud-download" variant="primary"></b-icon>
                                        <h5 class="text-primary mb-0 mt-2">{{ _gAuth.isAppSas() ? ((!_gHlp.isEmpty(current_commitment) && current_commitment.credit_report_platform === 'CBM') ? 'CBM Report' : 'Credit Report') : 'Credit Report' }} </h5>
                                    </b-button> -->
                                    <b-button
                                      v-if="
                                        (!_gAuth.isAppSas() && current_commitment.credit_report_platform === 'CBM') ||
                                        (_gAuth.isAppSas() && (current_commitment.credit_report_platform === 'CBM' || current_commitment.credit_report_platform === 'CTOS'))
                                      "
                                      class="border-right"
                                      :disabled="!current_commitment || current_commitment.credit_report_pdf_unsigned_url === ''"
                                      @click="$refs.preview_modal.preview(current_commitment.credit_report_pdf_unsigned_url)"
                                    >
                                      <b-icon icon="cloud-download" variant="primary"></b-icon>
                                      <h5 class="text-primary mb-0 mt-2">
                                        {{
                                          _gAuth.isAppSas()
                                          ? `${current_commitment.credit_report_platform} Report`
                                          : 'Credit Report'
                                        }}
                                      </h5>
                                    </b-button>
                                    <b-button class="border-left"
                                        :disabled="!current_commitment || current_commitment.credit_report_consent_unsigned_url === ''"
                                        @click="$refs.preview_modal.preview(current_commitment.credit_report_consent_unsigned_url,)"
                                    >
                                        <b-icon icon="cloud-download" variant="primary"></b-icon>
                                        <h5 class="text-primary mb-0 mt-2">Consent Form</h5>
                                    </b-button>
                                </b-button-group>
                        </div>
                    </b-col>
                    <b-col cols="12" class="d-flex justify-content-center py-2">
                        <b-button block variant="primary"
                            @click="openPurchaseReportDrawer"
                            v-if="!current_customer.cjp_id"
                        >
                            <div>
                                Purchase latest Report
                            </div>
                            <!-- <div v-else>
                                Purchase latest CBM<br>
                            </div> -->
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>

        <PreviewModal ref="preview_modal"></PreviewModal>

        <!-- Drawer for Net Income Details -->
        <drawer-buy-fintscore-report ref="drawer_buy_fintscore"  
            @new-purchase-report="$refs.drawer_fintscore_history.getCreditReportHistory()"
        ></drawer-buy-fintscore-report>
        <DrawerFintscoreReportHistory ref="drawer_fintscore_history" @open-purchase-report="openPurchaseReportDrawer"/>
    </div>
</template>
<script>
    import { Card, Button } from 'element-ui'
    import DrawerBuyFintscoreReport from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerFintscoreReport/DrawerFintscoreReport'
    import DrawerFintscoreReportHistory from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerFintscoreReport/DrawerFintscoreReportHistory'
    import PreviewModal  from '@/components/Modal/PreviewModal'
    import { mapState, mapActions } from 'pinia'
    import { useCustomerStore } from '@/stores/customerStore'
    import { useFintscoreStore } from '@/stores/fintscoreStore'
    import {
        notifyFunctionMixin
    } from '@/assets/js/httpImports.js'

    export default {
        name: 'fintscore-report',
        components: {
            [Card.name]: Card,
            [Button.name]: Button,
            DrawerBuyFintscoreReport,
            DrawerFintscoreReportHistory,
            PreviewModal
        },
        data(){
            return {
                is_loading_refresh: false,
            }
        },
        mixins:[
            notifyFunctionMixin,
          ],
        computed:{
            ...mapState(useCustomerStore, ['current_customer', 'current_commitment']),
            ...mapState(useFintscoreStore, ['fintscore_reports', 'discount_fintscore_price']),
            latest_fintscore(){
                let curr_report = null
                this.fintscore_reports.forEach((report) => {
                    if(report.fin_credit_report_id === this.current_commitment.credit_report_id){
                        curr_report = report
                    }
                })
                return curr_report
            }
        },
        methods:{
            ...mapActions(useCustomerStore, ['getCommitment']),
            ...mapActions(useFintscoreStore, ['generateFintscoreReport', 'getAllFintscoreReport']),
            openPurchaseReportDrawer(){
                this.$refs.drawer_buy_fintscore.viewDetails()
            },
            async generateFintscoreHandler(){
                let message = "Are you sure you want to generate Fintscore report?";
                if (confirm(message) == true) {
                    this.is_loading_refresh = true
                    let report_id = this.current_commitment.credit_report_id
                    try{
                        await this.generateFintscoreReport(report_id)
                        await this.getAllFintscoreReport(this.current_customer.customer_id)
                        this.notifySuccess('<b>Fintscore report - Successfully Generated.') 
                    }catch(e){
                        this.notifyError(e)
                    }
                    this.is_loading_refresh = false
                }
            },
            async refreshCTOSReport(){
                this.is_loading_refresh = true
                await this.getCommitment()
                this.is_loading_refresh = false
                this.notifySuccess('<b>Credit Report - Successfully Refreshed.')
            }
        }
    }
</script>